import {
  CLOSE_LOADER,
  LOADER_OPEN,
} from "../Component/store/dialogue/dialogue.type";
import { baseURL, secretKey } from "./config";
import store from "../Component/store/Provider";
import axios from "axios";

export const openSpinner = () => {
  return store.dispatch({ type: LOADER_OPEN });
};

export const closeSpinner = () => {
  return store.dispatch({ type: CLOSE_LOADER });
};

const getAuthHeaders = () => {
  const token = localStorage.getItem("token") || sessionStorage.getItem("token");

  return {
    "Content-Type": "application/json",
    key: `${secretKey}`,
    Authorization: `${token || ""}`,
  };
};

const clearAuthAndRedirect = () => {
  sessionStorage.clear();
  localStorage.clear();
  axios.defaults.headers.common["key"] = "";
  axios.defaults.headers.common["Authorization"] = "";
  window.location.href = "/";
};

export const apiInstanceFetch = {
  baseURL: `${baseURL}`, // Set your default base URL here
  get: (url) => {
    openSpinner();
    return fetch(`${apiInstanceFetch?.baseURL}${url}`, {
      method: "GET",
      headers: getAuthHeaders(),
    })
      .then(handleErrors)
      .finally(() => closeSpinner());
  },

  post: (url, data) => {
    openSpinner();
    return fetch(`${apiInstanceFetch.baseURL}${url}`, {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .finally(() => closeSpinner());
  },

  patch: (url, data) => {
    openSpinner();
    return fetch(`${apiInstanceFetch.baseURL}${url}`, {
      method: "PATCH",
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .finally(() => closeSpinner());
  },

  put: (url, data) => {
    openSpinner();
    return fetch(`${apiInstanceFetch.baseURL}${url}`, {
      method: "PUT",
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .finally(() => closeSpinner());
  },

  delete: (url) => {
    openSpinner();
    return fetch(`${apiInstanceFetch.baseURL}${url}`, {
      method: "DELETE",
      headers: getAuthHeaders(),
    })
      .then(handleErrors)
      .finally(() => closeSpinner());
  },
};

async function handleErrors(response) {
  if (response.status === 401 || response.status === 403) {
    let responseData = null;
    try {
      responseData = await response.clone().json();
    } catch (error) {
      responseData = null;
    }

    const message = (responseData?.message || responseData?.error || "").toLowerCase();
    const isAuthError =
      response.status === 401 ||
      message.includes("token") ||
      message.includes("authorized") ||
      message.includes("authorization");

    if (isAuthError) {
      clearAuthAndRedirect();
    }
  }

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response?.status}`);
  }

  return response.json();
}
